import { isSSR } from './global';

export const shouldClearBasket = () =>
  !isSSR && window.location && new URLSearchParams(window.location.search).get('clearCart');

export const getOrderId = () =>
  !isSSR && window.location && new URLSearchParams(window.location.search).get('orderId');
